import {
    getNewAssociatedFieldDefinitionReferences,
    getNewAttributes,
    getUpdatedAttAndFDRefAfterAttributeDeletion
} from './attributesUtils';

export const getValuesWithUpdatedAssociatedFieldDefinitionReferences = ({ values, fieldDefinitions, attributeIds }) => {
    const { associatedFieldDefinitionReferences } = getNewAssociatedFieldDefinitionReferences({
        existingAssociatedFDReferences: values.associatedFieldDefinitionReferences,
        attributeIds,
        fieldDefinitions
    });

    const updatedValues = {
        ...values,
        associatedFieldDefinitionReferences
    };

    return { updatedValues };
};

export const getValuesWithUpdatedAttributes = ({ values, attributes }) => {
    const { updatedAttributes } = getNewAttributes({
        existingAttributes: values.attributes,
        newAttributes: attributes
    });

    const updatedValues = {
        ...values,
        attributes: updatedAttributes
    };

    return { updatedValues };
};

export const getUpdatedValuesAfterAttributeDeletion = ({ values, fieldDefinitionId }) => {
    const { updatedAssociatedFieldDefinitionReferences, updatedAttributes } =
        getUpdatedAttAndFDRefAfterAttributeDeletion({ values, fieldDefinitionId });

    const updatedValues = {
        ...values,
        associatedFieldDefinitionReferences: updatedAssociatedFieldDefinitionReferences,
        attributes: updatedAttributes
    };

    return { updatedValues };
};
